import { render } from "./notice.vue?vue&type=template&id=c2a242a6&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=c2a242a6&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\DDP\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a242a6"]])

export default __exports__